import { ApplicationRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { ModalStockOperationCardComponent } from '../../components/modal-components/modal-stock-operation-card/modal-stock-operation-card.component'
import { ModalStatusComponent } from '../../components/modal-components/modal-status/modal-status.component'
import {
  Checkout,
  Currency,
  Depot,
  File,
  Producer,
  Product,
  ProductMove,
  ProductMovePack,
  PurchaseOrder,
  Supplier,
  Vat,
} from 'depoto-core/src/entities'
import { Events } from 'depoto-core/src/utils'
import { CoreService, NotificationService } from '../../services'
import { SchemaUtil, getThumbUrl as imageGetThumbUrl } from '../../utils'
import { TranslateService } from '@ngx-translate/core'
import * as Sentry from '@sentry/angular-ivy'
import { Router } from '@angular/router'
import { CompanyUtilService } from '../../services/company-util.service'

declare let disableBarcodeScanner: boolean

@Component({
  selector: 'stock-operation-list',
  templateUrl: 'stock-operation-list.component.html',
  styleUrls: ['stock-operation-list.component.scss'],
})
export class StockOperationListComponent implements OnInit, OnDestroy {
  @ViewChild('modalStockOperation') modalStockOperation: ModalStockOperationCardComponent
  @ViewChild('modalStockOperationProductCreate') modalStockOperationProductCreate: ModalStockOperationCardComponent
  // @ViewChild('modalStatus') modalStatus: ModalStatusComponent
  defaultCurrency: Currency
  products: Product[] = []
  operations: ProductMove[] = []
  depots: Depot[] = []
  suppliers: Supplier[] = []
  producers: Producer[] = []
  vats: Vat[] = []
  note = ''
  totalItems = 0
  currentPage: number
  endPage: number
  optionsVisible = false
  selectedDepotFrom: number
  selectedDepotTo: number
  searchFulltext = ''
  dateOperation = ''
  initDateDUZP: string
  sortProp = 'name'
  sortDir = 'asc'
  loading = true
  isPrintingEANs = false
  uploadedFiles: File[] = []
  areFilesUploading = false
  keyEventSubscriptions: any = {}
  isClonedPmp = false

  operationTypePage: string

  selectedCheckout: number
  checkouts: Checkout[]

  depotQuantity: number
  bindToOrderId: number
  bindToPurchaseOrderId: number
  isFilledFromPurchaseOrderData: boolean
  purchaseOrderData: any
  addedCostWithVat: number = 0

  constructor(
    private appRef: ApplicationRef,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private core: CoreService,
    private readonly router: Router,
    public companyUtil: CompanyUtilService,
  ) {
    Events.listen('filters:clear', () => {
      this.clearOptions()
      this.clearList(true)
    })
    const stockIn = this.router.getCurrentNavigation()?.extras?.state?.stockIn
    if (stockIn?.operations?.length) {
      this.isFilledFromPurchaseOrderData = true
      this.operations = []
      this.selectedDepotTo = stockIn.depotTo
      this.bindToPurchaseOrderId = stockIn.purchaseOrderId
      // make it work with packages, like every other route to add products here..
      // console.log({ stockIn })
      stockIn.operations.forEach(o => {
        // note: when transferring
        // let amount = o.amount
        // if (o.product?.tags?.some(tag => tag.externalId === 'hs-count-by-piece')) {
        //   console.log('pack!', o.product.packs?.find(p => p.externalId === 'hs-count-by-piece')?.quantity)
        //   amount = o.product.packs?.find(p => p.externalId === 'hs-count-by-piece')?.quantity
        // }
        // o.amount = amount // nope! this should finally fix this fucking package/piece mess:
        // o.amount = amount * o.purchaseOrderItem?.quantity // nope
        // console.log('oItem q: ',o.purchaseOrderItem?.quantity)
        o.purchasePriceSum = o.purchasePrice * o.amount
        this.addOperationToList(o)
      })
      this.operations = [...this.operations].map(o => ({ ...o, depotTo: stockIn.depotTo }))
      this.purchaseOrderData = stockIn
      setTimeout(() => {
        this.appRef.tick()
      }, 50)
    } else {
      this.isFilledFromPurchaseOrderData = false
    }
  }

  async ngOnInit() {
    this.loading = true
    if (window.location.href.split('/').pop() === 'stock-batch-in') {
      this.operationTypePage = 'in'
    } else this.operationTypePage = 'out'
    await this.refreshOptionsData().then(() => {
      if (!this.isFilledFromPurchaseOrderData) {
        this.loadViewSettings()
      }
      if (this.operationTypePage === 'in') {
        if (this.depots?.length === 1) this.selectedDepotTo = this.depots[0].id
        this.search()
      } else if (this.operationTypePage === 'out' && this.checkouts?.length === 1) {
        this.selectedCheckout = this.checkouts[0].id
        this.getCheckoutDepots()
      }
      this.defaultCurrency = this.core.services.user?.user?.company?.currency
    })
    this.keyEventSubscriptions.scannedBarcode = this.core.services.keyEvent.onScannedBarcode.subscribe().then(code => {
      if (disableBarcodeScanner) {
        return
      }
      this.searchFulltext = code
      this.search().then((products: Product[]) => {
        if (products && products.length === 1) {
          setTimeout(() => {
            this.modalStockOperation?.showProductOnChildModal(products[0])
            this.products = []
            this.searchFulltext = ''
          }, 100)
        }
        if (!products || (products && products.length < 1)) {
          setTimeout(() => {
            this.modalStockOperation?.showProductOnChildModal(null, true, this.searchFulltext)
            this.products = []
            this.searchFulltext = ''
          }, 100)
        }
        setTimeout(() => this.appRef.tick(), 200)
        setTimeout(() => this.appRef.tick(), 500)
        this.loading = false
      })
    })
    this.loading = false
  }

  async selectedCheckoutChanged(event) {
    this.selectedCheckout = event
    await this.getCheckoutDepots()
  }

  async getCheckoutDepots() {
    const checkout = this.checkouts.find(checkout => checkout.id === Number(this.selectedCheckout))
    this.depots = checkout.depots.filter(depot => this.core.services.user?.user?.depots?.some(d => d.id === depot.id))
    if (this.depots?.length === 1) {
      if (this.operationTypePage !== 'in') {
        this.selectedDepotFrom = this.depots[0]?.id
      }
      await this.search()
    } else {
      this.selectedDepotFrom = undefined
      this.products = []
    }
  }

  ngOnDestroy() {
    if (this.keyEventSubscriptions.scannedBarcode) {
      this.keyEventSubscriptions.scannedBarcode.unsubscribe()
      this.keyEventSubscriptions.scannedBarcode = null
    }
  }

  loadViewSettings(): void {
    let settings
    if (this.operationTypePage === 'in') {
      settings = this.core.services.storage.getSync(this.core.services.storage.keys.views.stockOperationListIn)
    } else {
      settings = this.core.services.storage.getSync(this.core.services.storage.keys.views.stockOperationListOut)
    }

    if (
      settings &&
      Object.keys(settings).length > 0 &&
      ((this.operationTypePage === 'out' && settings.selectedDepotFrom > 0 && !settings.selectedDepotTo) ||
        (this.operationTypePage === 'in' && settings.selectedDepotTo > 0 && !settings.selectedDepotFrom))
    ) {
      this.optionsVisible = settings.optionsVisible
      if (this.operationTypePage === 'in') {
        const doesSelectedDepotToExists =
          this.depots.map(d => d.id).filter(d => d === Number(settings.selectedDepotTo)).length > 0
        if (doesSelectedDepotToExists && !!settings.selectedDepotTo) {
          this.selectedDepotTo = settings.selectedDepotTo
        }
      }
      if (this.operationTypePage === 'out') {
        const doesSelectedCheckoutExists =
          this.checkouts.map(ch => ch.id).filter(ch => ch === Number(settings.selectedCheckout)).length > 0
        if (doesSelectedCheckoutExists && !!settings.selectedCheckout) {
          this.selectedCheckout = settings.selectedCheckout
        }
        const doesSelectedDepotFromExists =
          this.depots.map(d => d.id).filter(d => d === Number(settings.selectedDepotFrom)).length > 0
        if (doesSelectedDepotFromExists && !!settings.selectedDepotFrom) {
          this.selectedDepotFrom = settings.selectedDepotFrom
        } else if (this.selectedCheckout) this.getCheckoutDepots()
      }
      if (settings?.operations?.length) {
        this.operations = settings?.operations?.map(op => new ProductMove(op))
      } else {
        this.operations = []
      }
      this.searchFulltext = settings.searchFulltext
      this.dateOperation = settings.dateOperation
      this.sortProp = settings.sortProp
      this.sortDir = settings.sortDir
      this.note = settings.note
      this.uploadedFiles =
        settings.uploadedFiles && settings.uploadedFiles.length > 0 ? settings.uploadedFiles.map(f => new File(f)) : []
    }
  }

  async depotFromSelected(event) {
    this.selectedDepotFrom = event
    await this.search()
  }

  saveViewSettings(): void {
    const settings = {
      operationTypePage: this.operationTypePage,
      selectedCheckout: this.selectedCheckout,
      optionsVisible: this.optionsVisible,
      selectedDepotFrom: this.selectedDepotFrom,
      selectedDepotTo: this.selectedDepotTo,
      operations: this.operations,
      dateOperation: this.dateOperation,
      searchFulltext: this.searchFulltext,
      sortProp: this.sortProp,
      sortDir: this.sortDir,
      note: this.note,
      uploadedFiles: this.uploadedFiles,
    }
    if (this.operationTypePage === 'in') {
      this.core.services.storage.set(this.core.services.storage.keys.views.stockOperationListIn, settings)
    } else {
      this.core.services.storage.set(this.core.services.storage.keys.views.stockOperationListOut, settings)
    }
  }

  async refreshOptionsData(): Promise<any> {
    this.checkouts = this.core.lists.checkouts.filter(
      checkout =>
        checkout.name !== 'all' && this.core.services.user?.user?.checkouts?.some(ch => ch.id === checkout.id),
    )
    if (this.checkouts?.length === 1) {
      this.selectedCheckout = this.checkouts[0]?.id
      await this.getCheckoutDepots()
    }
    this.depots = this.core.lists.depots.filter(depot => {
      return depot.name !== 'all' && this.core.services.user?.user?.depots?.some(d => d.id === depot.id)
    })
    this.suppliers = this.core.lists.suppliers
    this.producers = this.core.lists.producers
    this.vats = this.core.lists.vats
  }

  clearOptions(type?: string): void {
    switch (type) {
      case 'depots':
        this.selectedDepotFrom = null
        this.selectedDepotTo = null
        break
      default:
        this.selectedDepotFrom = null
        this.selectedDepotTo = null
        this.dateOperation = null
        this.searchFulltext = ''
        this.products = []
        this.note = ''
        this.uploadedFiles = []
        this.bindToOrderId = undefined
        this.bindToPurchaseOrderId = undefined
        break
    }
    this.saveViewSettings()
  }

  clearList(isWithoutConfirmation = false): void {
    if (!isWithoutConfirmation && !confirm(this.translateService.instant('stock-operation-list.delete.confirm'))) {
      return
    }
    this.operations = []
    this.selectedCheckout = null
    this.selectedDepotTo = null
    this.selectedDepotFrom = null
    this.saveViewSettings()
  }

  filterKeyDown(event): void {
    if (event.key === 'Enter') {
      this.search()
    }
  }

  async search(
    pageNo = 1,
    sortProp: string = this.sortProp,
    sortDir: string = this.sortDir,
    concat = false,
  ): Promise<any> {
    this.loading = true
    this.currentPage = pageNo
    const filters: any = {
      listType: 'children_and_parents_without_children',
      fulltext: this.searchFulltext.trim(),
      enabled: true,
    }
    if (this.operationTypePage === 'out' && this.selectedDepotFrom) {
      filters.depots = [Number(this.selectedDepotFrom)]
      filters.availability = 'stock'
    }
    const receivedData = await this.core.services.product.getList(
      { page: pageNo, sort: sortProp, direction: sortDir, filters: filters },
      SchemaUtil.product,
    )
    if (receivedData) {
      if (!concat) {
        this.products = receivedData.items
      } else {
        receivedData.items.forEach(prod => {
          this.products.push(new Product(prod))
        })
      }
      this.totalItems = receivedData.paginator ? receivedData.paginator.totalCount : 0
      this.endPage = receivedData.paginator ? receivedData.paginator.endPage : 0
      setTimeout(() => (this.loading = false), 300)
      return this.products
    }
    setTimeout(() => (this.loading = false), 300)
  }

  getDepotQuantity(prod): number {
    let quantity
    if (this.operationTypePage === 'out') {
      const quantities = prod.quantities.filter(
        quantity => Number(quantity.depot.id) === Number(this.selectedDepotFrom),
      )
      this.depotQuantity = Number(
        quantities.reduce((total, q) => {
          return Number(total) + Number(q.quantityStock)
        }, 0),
      )
      quantity = this.depotQuantity
      if (this.operations?.length > 0) {
        const operationsWithSameProduct = this.operations.filter(op => Number(op.product?.id) === Number(prod.id))
        const quantityOfPushed = operationsWithSameProduct.reduce((total, op) => {
          return Number(total) + Number(op.amount)
        }, 0)
        if (operationsWithSameProduct) quantity = Number(quantity) - quantityOfPushed
      }
    } else if (this.operationTypePage === 'in') {
      quantity = prod.quantityStock
    }
    return quantity
  }

  sortBy(property: string): void {
    if (this.sortProp === property) {
      if (this.sortDir === 'asc') {
        this.sortDir = 'desc'
      } else {
        this.sortDir = 'asc'
      }
    } else {
      this.sortProp = property
    }
    this.saveViewSettings()
  }

  importBatchFromFile(operations: ProductMove[]): void {
    operations.forEach(op => this.addOperationToList(op))
    this.operations = [...this.operations]
    setTimeout(() => {
      this.appRef.tick()
    }, 50)
  }

  createBatchFromFile(res: any[]): void {
    if (res && res.length > 0) {
      const errorsInResponse = res.filter(r => Array.isArray(r) && typeof r[0] === 'string')
      if (errorsInResponse.length > 0) {
        this.notificationService.error(
          this.translateService.instant('stock-operation-list.create.error', { error: errorsInResponse.join(',') }),
          null,
          true,
        )
        Sentry.captureMessage('list::createBatchFromFile errors: ' + res)
      } else {
        this.notificationService.success(this.translateService.instant('stock-operation-list.create.success'))
        this.search()
      }
    }
  }

  operationListChange(moves: ProductMove[]) {
    this.operations = moves
    this.saveViewSettings()
    this.appRef.tick()
  }

  addOperationToList(operation: ProductMove): void {
    if (!operation || (operation && !operation.product)) {
      if (Array.isArray(operation) && operation.length > 0) {
        operation.forEach(err => {
          this.notificationService.error(
            this.translateService.instant('stock-operation-list.save.error', {
              error: err && err.message ? err.message : err,
            }),
            null,
            true,
          )
        })
      } else {
        this.notificationService.error(this.translateService.instant('stock-operation-list.save.error.500'), null, true)
      }
      return
    }

    if (this.operationTypePage === 'in' && operation.amount <= 0) {
      alert(this.translateService.instant('stock-operation-list.not-possible-to-store-in-minus'))
      return
    }

    operation = new ProductMove(operation)
    if (this.operationTypePage === 'out') {
      this.handleOperationTypeOut(operation)
    } else {
      let exists = false
      this.operations.forEach((op: ProductMove, i: number) => {
        if (this.isProductInOperationsYet(op, operation)) {
          exists = true
          this.operations[i].amount = Number(op.amount) + Number(operation.amount)
          this.operations[i].purchasePriceSum = Number(op.purchasePriceSum) + Number(operation.purchasePriceSum)
          this.operations[i].supplier = operation.supplier
        }
      })
      if (!exists) {
        this.operations.push(operation)
      }
      this.saveViewSettings()
      this.appRef.tick()
    }
  }

  updateOperation(operation: ProductMove): void {
    if (Array.isArray(operation)) {
      // vole! why is moves array on the fckn modal..?
      operation = operation[0]
    }
    operation = new ProductMove(operation)
    if (this.operationTypePage === 'out') {
      this.handleOperationTypeOut(operation)
    } else {
      this.operations.forEach((op: ProductMove, i: number) => {
        if (op.product.id === operation.product.id) {
          this.operations[i] = operation
          this.saveViewSettings()
          this.appRef.tick()
          return
        }
      })
    }
  }

  removeOperation(operation: ProductMove): void {
    this.operations.forEach((op: ProductMove, i: number) => {
      if (op === operation) {
        this.operations.splice(i, 1)
        this.saveViewSettings()
        this.appRef.tick()
        return
      }
    })
  }

  async handleOperationTypeOut(selectedOperation: ProductMove): Promise<void> {
    this.operations.push(selectedOperation)
    this.saveViewSettings()
    this.appRef.tick()
  }

  isProductInOperationsYet(operation, selectedOperation): boolean {
    return (
      operation.product.id === selectedOperation.product.id &&
      operation.purchasePrice === selectedOperation.purchasePrice &&
      operation.sellPrice === selectedOperation.sellPrice &&
      operation.batch === selectedOperation.batch &&
      operation.expirationDate === selectedOperation.expirationDate &&
      operation.purchaseCurrency === selectedOperation.purchaseCurrency &&
      operation.purchaseCurrencyDate === selectedOperation.purchaseCurrencyDate &&
      operation.position1 === selectedOperation.position1 &&
      operation.position2 === selectedOperation.position2 &&
      operation.position3 === selectedOperation.position3
    )
  }

  updateNote(note: string): void {
    this.note = note
    this.saveViewSettings()
  }

  createStockLoad(): void {
    this.loading = true
    if (this.operationTypePage === 'out') {
      this.operations.forEach(op => {
        delete op.batch
        delete op.supplier
        delete op.expirationDate
        delete op.purchasePrice
      })
    }
    if (this.operationTypePage === 'in' && this.addedCostWithVat > 0) {
      this.calcAddedCostValue(this.addedCostWithVat)
    }
    const movePack: ProductMovePack = new ProductMovePack({
      type: { id: this.operationTypePage },
      moves: this.operations,
      depotFrom: {
        id: this.selectedDepotFrom ? this.selectedDepotFrom : null,
      },
      depotTo: {
        id: this.selectedDepotTo ? this.selectedDepotTo : null,
      },
    })
    if (this.operationTypePage === 'out') {
      // @ts-ignore
      movePack.checkout = { id: this.selectedCheckout }
    }
    if (this.note && this.note !== 'null') {
      movePack.note = this.note
    }
    if (this.bindToPurchaseOrderId > 0) {
      movePack.purchaseOrder = new PurchaseOrder({ id: this.bindToPurchaseOrderId })
    }
    if (this.operationTypePage === 'in' && this.addedCostWithVat > 0) {
      movePack.incidentalCosts = this.addedCostWithVat
    }
    console.log({ movePack })
    this.core.services.productMovePack
      .create(movePack)
      .then(result => {
        if (result && result.id) {
          this.notificationService.success(
            this.translateService.instant(`alert.${this.operationTypePage === 'in' ? 'loading' : 'unloading'}.stock`),
          )
          this.loading = true
          window['selectedSupplier'] = undefined
          this.updateUploadedFilesWithProductMovePackId(result.id)
            .then(res => {
              this.loading = false
              this.clearOptions()
              this.clearList(true)
              this.addedCostWithVat = 0
              // this.modalStatus.showChildModal(
              //   this.translateService.instant('info'),
              //   this.translateService.instant('stock-in-page.success'),
              //   true,
              // )
            })
            .catch(e => `createStockLoad err, on fileUpdate: ${e.message}`)
        } else {
          // this.modalStatus.showChildModal(
          //   'stock-operation-list.warning',
          //   this.translateService.instant('stock-operation-list.processing-error'),
          //   true,
          // )
        }
        this.loading = false
      })
      .catch(error => {
        this.loading = false
        alert(
          this.translateService.instant('stock-operation-list.error') +
            (error && error.message ? error.message : typeof error === 'string' ? error : ''),
        )
        Sentry.captureException(error)
      })
  }

  printingSelect(type: string): void {
    let ops: any[] = []
    switch (type) {
      case 'all':
        ops = this.operations.map(op => {
          op.isEANPrintable = true
          return op
        })
        break
      case 'none':
        ops = this.operations.map(op => {
          op.isEANPrintable = false
          return op
        })
        break
      case 'invert':
        ops = this.operations.map(op => {
          op.isEANPrintable = !op.isEANPrintable
          return op
        })
        break
    }
    this.operations = ops
  }

  refreshOperationsHack(): void {
    // we need just to initiate pipe reload
    this.operations = [...this.operations]
  }

  uploadFiles(inputEvent: any): Promise<Array<File> | any> {
    this.areFilesUploading = true
    return new Promise((resolve, reject) => {
      if (inputEvent.target.files && inputEvent.target.files.length > 0) {
        const files = Array.from(inputEvent.target.files)
        const promisesBase64s = files.map(f => this.processUploadedFileToBase64(f))
        Promise.all(promisesBase64s)
          .then(resolvedBase64s => {
            const promisesUploads = resolvedBase64s.map(b => {
              return this.core.services.file.create(new File(b))
            })
            return Promise.all(promisesUploads).then(res => {
              this.uploadedFiles.push(...res)
              this.notificationService.success(this.translateService.instant('alert.file.uploaded'))
              let i = 0
              for (const r of res) {
                this.uploadedFiles[i]['filename'] = files[i]['name']
                i++
              }
              this.saveViewSettings()
              return res
            })
          })
          .catch(e => {
            console.log(e)
          })
          .then((resolvedUploadedFiles: File[] | void) => {
            this.areFilesUploading = false
            resolve(resolvedUploadedFiles)
          })
          .catch(e => console.log(e))
      } else {
        this.areFilesUploading = false
        reject(this.translateService.instant('no-file'))
      }
    })
  }

  processUploadedFileToBase64(file: any): Promise<string | any> {
    return new Promise((resolve, reject) => {
      if (file) {
        const reader = new FileReader()
        reader.readAsBinaryString(new Blob([file]))
        reader.onload = evt => {
          resolve({
            text: file.name,
            originalFilename: file.name,
            mimeType: file.type,
            base64Data: `data:application/octet-stream;base64,${btoa(String(evt.target['result']))}`,
          })
        }
        reader.onerror = () => {
          reject(this.translateService.instant('stock-operation-list.file-processing-error'))
        }
      } else {
        reject(this.translateService.instant('no-file'))
      }
    })
  }

  updateUploadedFilesWithProductMovePackId(pmpId: number): Promise<Array<any>> {
    return new Promise(resolve => {
      if (!this.uploadedFiles || (this.uploadedFiles && this.uploadedFiles.length === 0)) {
        return resolve([])
      }
      const promises = this.uploadedFiles.map(f => this.core.services.file.update(f, null, null, null, null, pmpId))
      Promise.all(promises).then(res => {
        resolve(res)
      })
    })
  }

  removeUploadedFile(file: File) {
    if (file && file.id > 0) {
      this.uploadedFiles.forEach((f, i) => {
        if (file.id === f.id) {
          try {
            this.uploadedFiles.splice(i, 1)
            this.notificationService.success(this.translateService.instant('alert.file.removed'))
          } catch (err) {
            console.log(err)
          }
        }
      })
      this.saveViewSettings()
    }
  }

  isProductExpired(product) {
    const newDate = new Date()
    const todayDate = newDate.getTime()
    return product.productDepots.some(productDepot => {
      if (productDepot.expirationDate?.length > 0 && productDepot.quantityStock > 0 && this.getDepotQuantity(product)) {
        const expDate = new Date(productDepot.expirationDate)
        return expDate.getTime() < todayDate
      } else {
        return false
      }
    })
  }

  getThumbUrl(image: File, format: 'w135wp' | 'w2048wp' = 'w135wp'): string {
    return imageGetThumbUrl(image, format)
  }

  calcAddedCostValue(addCostValue: number) {
    function addVAT(price: number, vat: number): number {
      return price * (1 + (vat || 0) / 100)
    }

    function removeVAT(price: number, vat: number): number {
      return price / (1 + (vat || 0) / 100)
    }

    const totalSumWithVAT = (this.operations as ProductMove[]).reduce(
      (acc, m) => acc + addVAT(m.purchasePrice, m?.product?.vat?.percent || 0) * m.amount,
      0,
    )

    const processedMoves = this.operations.map(m => {
      const sumRelation = (addVAT(m.purchasePrice, m?.product?.vat?.percent || 0) * m.amount) / totalSumWithVAT
      const addCostShare = removeVAT(addCostValue * sumRelation, m?.product?.vat?.percent || 0) / m.amount
      return {
        ...m,
        purchasePrice: Number((m.purchasePrice + addCostShare).toFixed(2)),
        purchasePriceSum: Number((m.purchasePrice + addCostShare).toFixed(2)) * m.amount,
      }
    })
    this.operations = processedMoves
  }

  getOperationPrice(op: ProductMove) {
    if (this.operationTypePage === 'in') {
      if (op.product?.tags?.some(tag => tag.externalId === 'hs-count-by-piece')) {
        return op.purchasePrice / op.product.packs?.[0]?.quantity
      } else {
        return op.purchasePrice || 0
      }
    } else {
      // todo this should not display price at all! but wait for confirmation from Michael Illa..
      // console.log({op})
      // console.log(op?.product?.productDepots)
      // console.log(op?.product?.productDepots?.filter(pd => pd.depot.id === Number(this.selectedDepotFrom)))
      // console.log(this.selectedDepotFrom)
      // return op?.product?.productDepots?.find(pd => pd.depot.id === Number(this.selectedDepotFrom))?.purchasePrice
      return op?.product?.productDepots?.find(pd => pd.id === Number(op.productDepot))?.purchasePrice
      // return op?.purchasePrice
    }
  }
}
